import React from 'react';
import { Col, Row } from 'react-bootstrap';

import ChatImage from '../../ChatImage';

import StreamTextDisplay from 'blockscope/components/aiSystem/panel/StreamTextDisplay';

/**
 * Renders standard messages containing text, images, or JSON
 * @param {Object} props - Component props
 * @param {Object} props.message - Message object to display
 */
const DefaultMessage = ({ message }) => {
  // Handle array of content (text, images, JSON)
  if (Array.isArray(message.content)) {
    return (
      <div className={message.role === 'user' ? 'text-end' : ''}>
        {/* Images section */}
        {message.content.some((m) => m.type === 'image') && (
          <div className='mb-2'>
            <Row
              className={`g-2 ${
                message.role === 'user' ? 'justify-content-end' : ''
              }`}
              style={{ maxWidth: '100%' }}
            >
              {message.content
                .filter((m) => m.type === 'image')
                .map((m) => m.image)
                .map((img, index) => (
                  <Col xs={6} md={4} key={index} style={{ maxWidth: '100%' }}>
                    <ChatImage image={img} />
                  </Col>
                ))}
            </Row>
          </div>
        )}

        {/* JSON indicators */}
        {message.content.some((m) => m.type === 'json') && (
          <div className='mb-2'>
            <Row
              className={`g-2 ${
                message.role === 'user' ? 'justify-content-end' : ''
              }`}
              style={{ maxWidth: '100%' }}
            >
              {message.content
                .filter((m) => m.type === 'json')
                .map((json, index) => (
                  <Col
                    xs={2}
                    key={index}
                    style={{ maxWidth: '60px', padding: '0 4px' }}
                  >
                    <div
                      className='bg-white rounded cursor-pointer'
                      style={{
                        height: 50,
                        width: '100%',
                        padding: 4,
                        border: '1px solid #ccc',
                      }}
                    >
                      <div
                        className={`h-100 w-100 d-flex align-items-center justify-content-center rounded ${
                          message.role === 'user'
                            ? 'bg-800 text-white'
                            : 'bg-light text-dark'
                        }`}
                      >
                        <span className='fw-bold fs--1'>JSON</span>
                      </div>
                    </div>
                  </Col>
                ))}
            </Row>
          </div>
        )}

        {/* Text section */}
        {message.content.some((m) => m.type === 'text') && (
          <div className='mb-2'>
            {message.content
              .filter((m) => m.type === 'text')
              .map((m, index) => (
                <StreamTextDisplay
                  key={index}
                  text={m.text}
                  className={'text-start'}
                />
              ))}
          </div>
        )}
      </div>
    );
  } else {
    // Simple string content
    return (
      <StreamTextDisplay
        text={message.content}
        className={message.role === 'user' ? 'text-end' : ''}
      />
    );
  }
};

export default DefaultMessage;
